module.exports = __webpack_public_path__ + "img/东久电子.5e522d08.png";